import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api/content`;

export const GALLERY_CATEGORIES = [
  "College Expert Sessions", "Student Workshops", "UPI Sessions", "AI and ML Sessions",
  "Classroom Activities", "Internship Programs", "Founder Speaking Events", "Team Activities",
];
export const BLOG_CATEGORIES = [
  "Artificial Intelligence", "Generative AI", "Machine Learning", "UPI", "Digital Payments",
  "Cloud Computing", "DevOps", "SQL", "Linux", "Career Guidance", "Interview Preparation", "College Students",
];

export const fetchContent = async (kind, category) => {
  const params = category && category !== "All" ? { category } : {};
  return (await axios.get(`${API}/${kind}`, { params })).data.items;
};
export const fetchBlogPost = async (slug) => (await axios.get(`${API}/blog/${slug}`)).data;

// Resolve a stored media reference to a full URL.
// Handles pasted external URLs, data/blob URLs, and our relative /api/content/file/... paths.
export const resolveMedia = (u) => {
  if (!u) return "";
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  return `${BASE}${u.startsWith("/") ? "" : "/"}${u}`;
};

// Convert any YouTube URL (watch, youtu.be, shorts, embed) to an embeddable URL.
export const youtubeEmbed = (url) => {
  if (!url) return null;
  const m = String(url).match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|[?&]v=)([A-Za-z0-9_-]{6,})/
  );
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};
